


























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class RewardCell extends Vue {
  @Prop() rewardStatus: string | undefined
  @Prop() rewardRecord: string | undefined

  get displayName () {
    if (this.rewardStatus === 'unprocessed') {
      return '未謝礼'
    }
    if (this.rewardStatus === 'processed') {
      return '謝礼済'
    }
    return '対象外'
  }

  get dateYear () {
    return this.rewardRecord ? moment(this.rewardRecord).format('YYYY') : ''
  }

  get dateMonthAndDate () {
    return this.rewardRecord ? moment(this.rewardRecord).format('MM/DD') : ''
  }

  get isChecked () {
    if (!this.rewardStatus || this.rewardStatus !== "processed") {
      return false
    }
    return true
  }

  get canReward () {
    if (this.rewardStatus === "unprocessed" || this.rewardStatus === "processed") {
      return true
    }
    return false
  }

  onRewardRecordStatusChange (event: any) {
    console.log('onRewardRecordStatusChange - event:', event)
    this.$emit('rewardRecordStatusChange', event)
  }
}

